import React, { Fragment } from 'react';
import { Separator, VStack } from '@skin-seoul/design-system';
import type { FiboSearchHeadline } from '@skin-seoul/service';
import { FiboSearchHeadlineText } from '@skin-seoul/service';
import type { GroupedFiboHeadlineWithItems } from '@skin-seoul/service';
import { FibosearchCombobox } from './FibosearchCombobox';
import { RenderItem } from './RenderItem';
export type GroupContentProps = {
  groupedCollection: Array<[FiboSearchHeadline, GroupedFiboHeadlineWithItems]>;
  inputValue: string;
  onClose?: () => void;
};
export const CollectionGroup = ({
  groupedCollection,
  inputValue,
  onClose
}: GroupContentProps) => <>
    {groupedCollection.map(([key, groupData]) => <FibosearchCombobox.ItemGroup key={key}>
        <VStack width="100%" paddingY="4px" gap={1} alignItems="flex-start">
          <FibosearchCombobox.ItemGroupLabel textStyle="label.small" textTransform="uppercase" color="neutral.900">
            {FiboSearchHeadlineText[key]}
          </FibosearchCombobox.ItemGroupLabel>
          <Separator width="100%" borderColor="neutral.100" />
        </VStack>
        {groupData.items.map(item => <Fragment key={item.label}>
            <RenderItem item={item} inputValue={inputValue} onClose={onClose} />
          </Fragment>)}
      </FibosearchCombobox.ItemGroup>)}
  </>;